import React from "react"
import PropTypes from "prop-types"
import SelectField from "material-ui/SelectField"
import MenuItem from "material-ui/MenuItem"
import TextField from "material-ui/TextField"
import AppStateStore from "../../stores/AppStateStore"

const moment = require("moment")
const propTypes = {
    onValueChange: PropTypes.func,
    style: PropTypes.object,
    state: PropTypes.string
}

export default class StateSelectField extends React.Component {
    constructor(props) {
        super()
        this.state = {
            state: "AL"
        }
        this.handleNativeComboChange = this.handleNativeComboChange.bind(this)
        this.handleChange = this.handleChange.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value) {
            this.setState({
                state: nextProps.value
            })
        }
    }

    handleChange(event, index, value) {
        this.setState(
            {
                state: value
            },
            () => {
                if (this.props.onValueChange) {
                    this.props.onValueChange(this.state.state)
                }
            }
        )
    }

    handleNativeComboChange(event) {
        const value = event.target.value
        this.setState(
            {
                state: value
            },
            () => {
                if (this.props.onValueChange) {
                    this.props.onValueChange(this.state.state)
                }
            }
        )
    }

    render() {
        const statesArray = [
            "AL",
            "AK",
            "AZ",
            "AR",
            "CA",
            "CO",
            "CT",
            "DE",
            "DC",
            "FL",
            "GA",
            "HI",
            "ID",
            "IL",
            "IN",
            "IA",
            "KS",
            "KY",
            "LA",
            "ME",
            "MT",
            "NE",
            "NV",
            "NH",
            "NJ",
            "NM",
            "NY",
            "NC",
            "ND",
            "OH",
            "OK",
            "OR",
            "MD",
            "MA",
            "MI",
            "MN",
            "MS",
            "MO",
            "PA",
            "RI",
            "SC",
            "SD",
            "TN",
            "TX",
            "UT",
            "VT",
            "VA",
            "WA",
            "WV",
            "WI",
            "WY",
            "CAN",
            "MEX"
        ]

        if (AppStateStore.isMobile()) {
            return (
                <div
                    className="StateSelectField"
                    style={{
                        marginTop: 20,
                        marginBottom: 20,
                        textAlign: "left"
                    }}
                >
                    <div style={{ color: "#cccccc", marginBottom: 10 }}>State</div>
                    <select
                        value={this.state.state}
                        onChange={this.handleNativeComboChange}
                        style={{
                            width: "100%",
                            fontSize: "16px",
                            marginRight: 10,
                            border: "none",
                            borderBottom: "solid 1px #e1e1e1"
                        }}
                    >
                        {statesArray.map(function(value, i) {
                            return <option value={value}>{value}</option>
                        })}
                    </select>
                </div>
            )
        } else {
            return (
                <SelectField id="StateSelectField" floatingLabelText="State" value={this.state.state} onChange={this.handleChange} style={this.props.style}>
                    {statesArray.map(function(value, i) {
                        return <MenuItem value={value} primaryText={value} />
                    })}
                </SelectField>
            )
        }
    }
}

StateSelectField.propTypes = PropTypes
